define('modules/editor/models/elements/form',['require','exports','module','./base','./form_button','modules/form_editor/index','../editorstate','underscore','lib/util'],function (require, exports, module) {
  "use strict";
  var BaseElement = require("./base"),
      FormButton = require("./form_button"),
      FormEditorService = require("modules/form_editor/index"),
      EditorState = require("../editorstate"),
      _ = require("underscore"),
      util = require("lib/util");

  var Serialization = {
    toJSON: function(){
      var json = module.exports.__super__.toJSON.apply(this);
      _.extend(json,
               { fields: this.fields });
      return json;
    }
  };

  module.exports = BaseElement.extend({
    name: "element:form",
    defaultNameKey:"form",
    defaultPropertyGroups: [],
    propertyGroups: [
      {
        name: "form:geometry",
        defaults: { width: 300 }
      },
      {
        name: "idclass",
        defaults: {
          "id": "",
          "className": ""
        }
      },
      {
        name: "form:content",
        defaults: {
          content: ""
        }
      },
      {
        name: "form:conversion",
        defaults: {
          step: 0,
          executeConversion: false
        }
      },
      {
        name: "background",
        defaults: {
          color: "#ffffff",
          type: "solid",
          opacity: 0,
          secondColor: "#eeeeee",
          backgroundPosition: "left top",
          backgroundRepeat: "no-repeat",
          imageUrl: "",
          direction: "to left"
        }
      },
      {
        name: "border",
        defaults: {
          type: "none",
          width: 1,
          color: "#000000",
          position: "in",
          top: true,
          bottom: true,
          left: true,
          right: true,
          radius: 0
        }
      },
      {
        name: "form:submitFormat",
        defaults: {
          text: "Enviar",
          fontSize: 14,
          color: "#000000",
          width: 150,
          height: 32,
          fontWeight: "normal",
          fontFamily: "Arial",
          align: "left"
        }
      },
      {
        name: "button:style",
        defaults: {}
      },
      {
        name: "form:label",
        defaults: {
          fontWeight: "normal",
          fontFamily: "Arial",
          fontSize: 14,
          color: "#000",
          align: "left" //left,top label position with regards to input control
        }
      },
      {
        name: "form:inputFormat",
        defaults: {
          fontFamily: "Arial",
          backgroundColor: "#fff",
          height: 32,
          marginBottom: 18,
          fontSize: 14,
          borderRadius: 6,
          borderStyle: "solid",
          borderWidth: 1,
          borderColor: "#cccccc"
        }
      },
      {
        name: "form:radioFormat",
        defaults: {
          color: "#000",
          fontFamily: "Arial",
          fontWeight: "normal",
          fontSize: 14
        }
      },
      {
        name: "form:customAMPScript",
        defaults: {
          customScriptURL: "",
          customScriptContent: ""
        }
      },
      {
        name: "form:integration:correodirect",
        defaults: {
          active: false,
          idaf: "",
          fields: {}
        }
      }
    ],
    geometryProperty: "form:geometry",

    initialize: function(attributes, options){
      if(!attributes) attributes = {};
      this.fields = attributes.fields || [];
      delete attributes.fields;
      module.exports.__super__.initialize.call(this,attributes);
      this.watchLegalTerms();
    },

    onCreate: function(){
      var conversion = this.getPropertyGroup("form:conversion"),
          step = EditorState.getActivePage().get("step");
      conversion.set("step", step);
    },

    editFormFields: function(){
      FormEditorService.editForm(this.toJSON(), _.bind(this.saveFormEditorData, this));
    },

    saveFormEditorData: function(results){
      this.fields = results.model.fields;
      this.setPropertyGroups(results.model.properties);
      this.getPropertyGroup("form:content").set("content", results.content);
    },

    recalculateFixedButtonPosition: function() {
      return {x: 200, y: 200};
    },

    findFormButton: function() {
      var step = this.getPropertyGroup("form:conversion").get("step"),
          page = EditorState.getActivePage(),
          activeStep = page.collection.getStep(step),
          formButton;
      if(!activeStep || !activeStep.sections) return undefined;
      formButton = activeStep.sections.findElementByClass(FormButton);
      if(formButton){
        formButton.setFormModel(this);
        //formButton.setGeometryProp(this.getPropertyGroup("form:submitFormat"));
        formButton.silentlyUpdateButtonProperties(
          this.getPropertyGroup("form:submitFormat"),
          this.getPropertyGroup("button:style"));
      }
      return formButton;
    },

    createFormButton: function(rect) {
      // pass the formSubmitFormat property to the form button
      // so it can update it's own geometry in freemode, but
      // changes are still stored in the form model
      var button = new FormButton(null, {rect: rect, formModel: this }),
          activePage = EditorState.getActivePage(),
          section = activePage.sections.findContainerFor(this);
      if (section) {
        section.addElement(button);
        button.set("displayOrder", this.get("displayOrder"));
      }
      button.setFormModel(this);
      button.updateButtonProperties(
        this.getPropertyGroup("form:submitFormat"),
        this.getPropertyGroup("button:style"));
      //button.setGeometryProp(this.getPropertyGroup("form:submitFormat"));
      return button;
    },

    findOrCreateFormButton: function(rect) {
      return this.findFormButton() || this.createFormButton(rect);
    },

    removeButton: function() {
      var button = this.findFormButton();
      if (!button) { return; }
      button.destroy();
    },

    isButtonFree: function() {
      return "free" === this
        .getPropertyGroup("form:submitFormat").get("align");
    },

    updateFormButtonSize: function(size){
      this.getPropertyGroup("form:submitFormat").set({
        width: size.width,
        height: size.height
      }, { silent: true });
    },

    getGoogleRecaptchaData: function () {
      return _.findWhere(this.fields, { name: "custom:captcha:google_recaptcha" });
    },

    hasFacebookLogin: function(){
      return _.findWhere(this.fields, { name: "custom:login:facebook" });
    },

    hasLinkedInLogin: function(){
      return _.findWhere(this.fields, { name: "custom:login:linkedin" });
    },

    hasIBAN: function(){
      return _.findWhere(this.fields, { name: "custom:iban" });
    },

    hasLegal: function() {
      return !!(_.findWhere(this.fields, { elementId: "legal"}) && _.findWhere(this.fields, { elementId: "legal_sponsors" }));
    },

    getIntegrableFields: function() {
      var notIntegrableFields = ["custom:fblogin", "custom:terms"];
      var fields = _.filter(this.fields, function(field){
        return notIntegrableFields.indexOf(field.name) === -1;
      });
      return _.map(fields, function(field){
        return field.nameAttr || field.labelText;
      });
    },

    toggleCorreoDirect: function(active) {
      var integration = this.getPropertyGroup("form:integration:correodirect");
      active = active !== undefined ? active : !integration.get("active");
      integration.set("active", active);
    },

    watchLegalTerms: function() {
      var content = this.getPropertyGroup("form:content"),
          integration = this.getPropertyGroup("form:integration:correodirect");

      this.listenTo(content, "change:content", function(){
        var integrationActive = integration.get("active");
        if (integrationActive) {
          this.toggleLegalTerms();
        }
      });

      this.listenTo(content, "change:content", function(){
        var integrationActive = integration.get("active"),
          integratedFields = this.fields.filter(function(field){
            return field.correodirectBinding;
          });
        if (integrationActive && !integratedFields.length) {
          this._disableCorreoDirect();
        }
      });

      this.listenTo(integration, "change", function(integration){
        var active = integration.get("active"),
            idaf = integration.get("idaf"),
            page = EditorState.getActivePage();
        if (page){
          page.scripts.removeCorreoDirectScripts();
          page.scripts.toggleCorreoDirectScripts(idaf, active);
          page.styles.toggleCorreoDirectStyles(active);
        }
      });
    },

    toggleLegalTerms: function(toggle) {
      var pageConversion = this.getPropertyGroup("form:conversion"),
          hasLegal = toggle !== undefined ? toggle : this.hasLegal();
      if (!hasLegal && pageConversion.get("step") === 0) {
        this._disableCorreoDirect();
      }
    },

    _disableCorreoDirect: function() {
      var activePage = EditorState.getActivePage();
      if (activePage) {
        var steps = activePage.collection;
        steps && steps.forEach(function(page){
          var form = page.sections.getForm();
          form && form.toggleCorreoDirect(false);
        });
        this.trigger("integration:disabled");
      }
    },

    onRedraw: function(clientRect) {
      // a little unorthodox to have an "onRedraw" on the model,
      // but it doesn't have anything to do with rendering. This
      // method is forwarding the event to the button, which, in
      // turn, will forward it to it's own view. Think of this as
      // a not-very-elegant-but-works pipe system under the surface.
      var button;
      if (!this.isButtonFree()) {
        this.removeButton();
      } else {
        button = this.findOrCreateFormButton(
          _.extend({}, this.getPosition(), clientRect));
        // button.updateButtonProperties(
        //   this.getPropertyGroup("form:submitFormat"),
        //   this.getPropertyGroup("button:style"));
      }
    },

    onRemove: function(section) {
      this.removeButton();
    },

    selfClone: function(){
      if (!this.collection) return;
      var json = this.toJSON(),
          form = new this.constructor(_.omit(json, "name", "fields")),
          step = this.getPropertyGroup("form:conversion").get("step");
      form.getPropertyGroup("idclass").set("id", "");
      form.getPropertyGroup("form:content").set("content", "");
      form.getPropertyGroup("form:conversion").set({
        step: ++step,
        executeConversion: false
      });
      return form;
    },

    _getIntegrationMap: function(collection, attr) {
      collection = collection || [];
      attr = attr || "nameAttr";
      return collection.reduce(function(data, item){
        var name = item[attr],
            binding = item.correodirectBinding;
        if (binding) data[name] = binding;
        return data;
      }, {});
    },

    getIntegrationData: function() {
      return this._getIntegrationMap(this.fields);
    },

    getCompatData: function() {
      return _.reduce(this.fields, function(all, field){
        var map = _.filter(field.items, function(item){ return item.valid && item.correodirectBinding; }),
            compat = {};
        if (!_.isEmpty(map)) {
          compat.name = field.nameAttr;
          compat.map = map;
          all.push(compat);
        }
        return all;
      }, [], this);
    },

    toJSON: Serialization.toJSON,
    //fromJSON: Serialization.fromJSON
  });
  //util.mixin(module.exports, require("../../behaviours/has_linked_elements"));
});

